export class BuyerSeller {
  buyer: BuyerSellerContent;
  seller: BuyerSellerContent;
}

export class BuyerSellerContent {
  title: string;
  tabs: BuyerSellerTabs[];
}

export class BuyerSellerTabs {
  title: string;
  steps: BuyerSellerTab[];
}

export class BuyerSellerTab {
  description: string;
  content: BuyerSellerTabContent;
}

export class BuyerSellerTabContent {
  orderBook: BuyerSellerOrderBook;
  portfolio: BuyerSellerPortfolio;
}

export class BuyerSellerOrderBook {
  buyOrders: BuyerSellerTradeOrder[];
  sellOrders: BuyerSellerTradeOrder[];
}

export class BuyerSellerTradeOrder {
  volume: number;
  price: number;
  isHighlighted: string;
  isBold: boolean;
}

export class BuyerSellerPortfolio {
  business: string;
  quantity: number;
  investmentAmount: string;
  shareAveragePrice: string;
  isHighlighted: string;
}
